export const getItemDetailString = details => {
  return details
    .filter(detail => {
      return detail[Object.keys(detail)[0]];
    })
    .map(detail => Object.keys(detail)[0])
    .join(' · ');
};
